/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Badge } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import EnhancedToolbarStyles from '../../../styles/EnhancedDataTable/EnhancedTableToolbar/EnhancedTableToolbar';

export const badgeTheme = (selected) => ({
  boxSizing: 'border-box',
  height: '25px',
  width: '30px',
  border: `1px solid ${selected ? '#006FCF' : '#C8C9C7'}`,
  borderRadius: '15.5px',
  backgroundColor: selected ? '#006FCF' : '#F7F8F9',
  color: selected ? '#FFFFFF' : '#006FCF',
  fontFamily: 'Helvetica Neue',
  fontSize: '14px',
  letterSpacing: '0',
  lineHeight: '22px',
  textAlign: 'center',
});

export const ItemsPerPageBadges = React.memo((props) => {
  const { onItemsPerPageChange, itemsPerPage } = props;

  const options = [5, 10, 15, 20, 25];
  return options.map((item) => (
    <Badge
      key={`itemsPerPage-badge-${item}`}
      id={`itemsPerPage-badge-${item}${item === itemsPerPage ? '-current' : ''}`}
      onClick={(e) => onItemsPerPageChange(Number(e.target.getAttribute('value')))}
      css={EnhancedToolbarStyles['.itemsPerPageBadge']}
      theme={badgeTheme(item === itemsPerPage)}
      value={item}
    >{item}
    </Badge>
  ));
});

// eslint-disable-next-line max-params
export const humanFileSize = (bytes, si = false, dp = 1, space = false) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return `${bytes}${space ? ' ' : ''}${bytes}`;
  }

  const units = si
    ? ['kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    // eslint-disable-next-line no-param-reassign
    bytes /= thresh;
    // eslint-disable-next-line no-plusplus
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return `${bytes.toFixed(dp)}${space ? ' ' : ''}${units[u]}`;
};

ItemsPerPageBadges.displayName = 'ItemsPerPageBadges';

ItemsPerPageBadges.propTypes = {
  onItemsPerPageChange: PropTypes.func.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
};
